<form [formGroup]="pcgEntryForm">
  <div tiimeForm>
    <div tiimeFormColumn>
      <tiime-input-container
        tiimeFormInputContainer
        contentId="accountNumber"
        label="Numéro de compte"
        required="true"
        [errorMessage]="pcgEntryForm.accountNumberErrorMessage?.message"
      >
        <input
          #accountNumberInput
          [class.ng-invalid]="pcgEntryForm.accountNumberErrorMessage"
          [class.ng-touched]="pcgEntryForm.accountNumberErrorMessage"
          id="accountNumber"
          type="text"
          placeholder="Numéro de compte"
          formControlName="accountNumber"
          appFormUpdateOnBlur
          (formChanges)="onPcgEntryFormChange()"
          (blur)="onBlurAccountNumber()"
          autocomplete="off"
          data-cy="pcg-entry-account-number-input"
        />
      </tiime-input-container>
      <tiime-input-container
        tiimeFormInputContainer
        contentId="label"
        label="Nom de compte"
        required="true"
        [errorMessage]="pcgEntryForm.labelErrorMessage?.message"
      >
        <input
          id="label"
          type="text"
          placeholder="Nom de compte"
          formControlName="label"
          appFormUpdateOnBlur
          (formChanges)="emitPcgEntryFormChange()"
          autocomplete="off"
          data-cy="pcg-entry-label-input"
        />
      </tiime-input-container>
      <div class="toggle-container">
        <mat-slide-toggle
          color="primary"
          formControlName="centralizer"
          (change)="updateCentralizer()"
          data-cy="pcg-entry-centralizer-toggle"
        >
          Centralisateur
        </mat-slide-toggle>
      </div>
      @if (!pcgEntryForm.centralizer.value) {
        <div class="centralizer-pcg-entry-container">
          <app-centralizer-pcg-entry-select
            [ctrl]="pcgEntryForm.centralizerPcgEntry.id"
            [errorMessage]="pcgEntryForm.centralizerPcgEntryErrorMessage?.message"
            [pcgEntries]="centralizerPcgEntries"
            [required]="pcgEntryForm.accountNumber.value | map: mapToCentralizerPcgEntryRequired"
            label="Compte de centralisation"
            (emptyOptionSelected)="resetCentralizerPcgEntry($event)"
            (selectChange)="updateCentralizerPcgEntry($event)"
            (pcgEntryCreated)="onPcgEntryCreated($event)"
          ></app-centralizer-pcg-entry-select>
        </div>
      }
    </div>
  </div>
</form>
